import * as e from "react";
import c from "../lib/IconBase.es.js";
import r from "../defs/ListChecks.es.js";
const o = e.forwardRef((s, t) => /* @__PURE__ */ e.createElement(c, { ref: t, ...s, weights: r }));
o.displayName = "ListChecksIcon";
const m = o;
export {
  m as ListChecks,
  o as ListChecksIcon
};
